import Table from "../../../layouts/seller-hub/Table";

const Transaction = () => {
  return (
    <Table>
      <div className="w-full md:w-1/2">
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Customer name
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Payment date
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Delivery date
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Item selling price
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Discount
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Amount paid
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Customer feedback
        </div>
      </div>
      <div className="md:w-1/2">
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Ololade mi asake
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          #20,000
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          #0.00
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          #20,000
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">...</div>
      </div>
    </Table>
  );
};

export default Transaction;
